module.exports = __webpack_public_path__ + "img/pri-sig-web-logo.d066fccb.png";